import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import { loadBFWOrganizations } from '../actions';
import DocumentMeta from 'react-document-meta';
import CategoryPageBoxes from '../components/categoryDetailLandingPage/CategoryPageBoxes';
import BFWLps from '../components/buyFromWomen/BFWLps';
import { findIndex } from 'lodash/array'
import OrganizationsPagination from '../components/OrganizationsPagination'



class BuyFromWomenLP extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {
    let isSame = (
      this.props.params.slug == nextProps.params.slug
    );
  }

  componentWillMount() {
    this.props.loadBFWOrganizations({
      is_bfw_lp: true
    });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }



  render() {
    if (!this.props.baseState.isLoaded) {
      return <span />;
    }
    if (!this.props.bfwOrganizations.isLoaded) {
      return <span />;
    }


    let categories = this.props.baseState.categories;

    // BuyFromWomen<sup className="bfw-tm">&trade;</sup>  Product Category
    var i = findIndex(categories, { 'slug': 'buy-from-women-products' });
    let buyFromWomenProductsObj = {};

    buyFromWomenProductsObj = categories[i];


    // BuyFromWomen<sup className="bfw-tm">&trade;</sup>  Services Category
    var j = findIndex(categories, { 'slug': 'buy-from-women-services' });
    let buyFromWomenServicesObj = {};
    buyFromWomenServicesObj = categories[j];

    const meta = {
        title: 'WorldWideWomen | Buy from Women Owned Businesses',
        description: 'Buy from Women Owned Businesses',
    }

    return(
      <main>
        <div className="content-wrapper">
          <DocumentMeta {...meta} />
          <div className="buyFromWomen-bannerWrapper">
            <div className="buyFromWomen-bannerImage">
              <img className="buyFromWomen-desktop" src="/images/buy_from_women/banner/desktop/banner.jpg" />
              <img className="buyFromWomen-tablet" src="/images/buy_from_women/banner/tablet/banner.jpg" />
              <img className="buyFromWomen-mobile" src="/images/buy_from_women/banner/mobile/banner.jpg" />
            </div>

            <div className="buyFromWomen-bannerTagWrapperOuter">
              <div className="buyFromWomen-bannerTagWrapper">
                BuyFromWomen<sup className="bfw-tm">&trade;</sup>
              </div>
              <div className="buyFromWomen-bannerSubTagWrapper">Purchase goods and services from women-owned businesses</div>
            </div>
            <div className="buyFromWomen-bfwLogoOverlay">
              <img src="/images/buy_from_women/buy_from_women_overlay2.png" />
            </div>
          </div>


          <div className="buyFromWomen-wrapper">
            <div className="buyFromWomen-header">
              <h1 className="page-heading">Buy from Women-Owned Businesses</h1>
            </div>

            <p>Welcome to our new BuyFromWomen<sup className="bfw-tm-small">&trade;</sup> directory. The WorldWideWomen team is pleased to introduce this new directory featuring exceptional products and services created and offered by women.</p>

            <p>We are just in the beginning stages of growing this section category by category and city by city, so stay tuned and keep coming back to watch our growth.</p>

            <p>We invite women-owned businesses to hop aboard, <Link to="/apply-to-list-lp">apply to be listed</Link>, and help us launch a global movement to buy goods and services from our intrepid women entrepreneurs around the world!</p>

            <p>Please enjoy what we have so far...</p>

            <div className="buyFromWomen-btnWrapper">

              <div className="categoryDetail-boxesWrapper">
                <div className="buyFromWomen-subHeader">
                  <h2 className="page-heading">Buy from Women Owned Businesses: Services</h2>
                </div>

                <CategoryPageBoxes
                  categories={this.props.baseState.categories}
                  categoryObj ={buyFromWomenServicesObj}
                  browser={this.props.browser}/>
              </div>

              <div className="categoryDetail-boxesWrapper">
                <div className="buyFromWomen-subHeader">
                  <h2 className="page-heading">Buy from Women Owned Businesses: Products</h2>
                </div>
                <CategoryPageBoxes
                  categories={this.props.baseState.categories}
                  categoryObj ={buyFromWomenProductsObj}
                  browser={this.props.browser}/>
              </div>

            </div>

            <div className="buyFromWomen-orgListingsWrapper">
              <BFWLps
                bfwOrgs = {this.props.bfwOrganizations}
                user = {this.props.auth.user}
                loadBFWOrganizations = {this.props.loadBFWOrganizations}
              />
            </div>



          </div>

        </div>

      </main>

    )
  }
}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    loadBFWOrganizations
  })(BuyFromWomenLP);



// WEBPACK FOOTER //
// ./src/containers/BuyFromWomenLP.jsx